import { Grid, Typography } from "@mui/material"
import { motion } from "framer-motion";
interface Props {
    items: {
        label: string,
        value: any,
        disabled?: boolean
    }[],
    value: any,
    onChange: (newValue: any) => void
}

export const TabsComponent = ({
    items,
    onChange,
    value
}: Props) => {
    const selectedIndex = items.findIndex(item => item.value === value);

    return (
        <Grid
            sx={{
                width: "100%",
                height: "3.6rem",
                borderRadius: "9px",
                backgroundColor: "rgba(120, 120, 128, 0.12)",
                display: "flex",
                alignItems: "center",
                position: "relative",
            }}
        >
            {/* Fundo animado */}
            <motion.div
                style={{
                    position: "absolute",
                    top: "2px",
                    left: "2px",
                    height: "calc(100% - 4px)",
                    borderRadius: "7px",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "0px 3px 8px 0px #0000001F"

                }}
                animate={{
                    width: `calc((100% - 4px) / ${items.length})`,
                    translateX: `${selectedIndex * 100}%`,
                }}
                transition={{
                    type: "tween",
                    stiffness: 300,
                    damping: 30,
                }}
            />

            <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "space-between",
                    padding: "2px",
                    position: "relative",
                    zIndex: 1,
                }}
            >
                {items.map((item) => (
                    <Grid
                        key={item.value}
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => !item.disabled && onChange(item.value)}
                    >
                        <Typography
                            fontSize={"1.3rem"}
                            fontWeight={value === item.value ? "600" : "400"}
                            textAlign={"center"}
                            color={item.disabled ? "textDisabled" : "textPrimary"}
                        >
                            {item.label}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Grid >
    );
};